import HeroSection from "@/pages/home/components/HeroSection";
import LiveTicker from "@/pages/home/components/LiveTicker";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import IntelSection from "@/pages/home/components/IntelSection";
import TopicSection from "@/pages/home/components/TopicSection";
import FaqSection from "@/pages/home/components/FaqSection";
import BrandSection from "@/pages/home/components/BrandSection";
import BackToTop from "@/components/feature/BackToTop";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";

export default function Home() {
  useSeo({
    title: "看料大瓜 - 现场直击 实时追踪热点实况与目击者爆料",
    description:
      "看料大瓜专注热点事件现场直击，实时追踪热点实况，汇聚目击者亲历描述与事件时间线。吃瓜第一线，瓜田情报一站掌握，快速了解事件来龙去脉。",
    keywords: "看料大瓜,看料大瓜现场,看料大瓜直击,看料大瓜实况,吃瓜第一线,瓜田情报",
    canonical: "https://ahgslo.cn/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "看料大瓜",
        url: "https://ahgslo.cn/",
        description: "热点事件现场直击与瓜田情报内容平台，实时追踪热点实况。",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://ahgslo.cn/live?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
    ],
  });

  return (
    <main className="w-full">
      <HeroSection />
      <div className="mt-14 md:mt-20">
        <LiveTicker />
      </div>
      <FeaturedSection />
      <IntelSection />
      <TopicSection />
      <FaqSection />
      <BrandSection />
      <BackToTop />
    </main>
  );
}